import { render, staticRenderFns } from "./i-currency-input.vue?vue&type=template&id=f4c6bace&scoped=true&"
import script from "./i-currency-input.vue?vue&type=script&lang=js&"
export * from "./i-currency-input.vue?vue&type=script&lang=js&"
import style0 from "./i-currency-input.vue?vue&type=style&index=0&id=f4c6bace&lang=css&scoped=true&"
import style1 from "./i-currency-input.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c6bace",
  null
  
)

export default component.exports